/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, makeStyles } from "@material-ui/core";
import {
  CollectedOrders,
  OpenOrders,
  ReadyForCollectionOrders,
  FailedOrders,
} from "../components-organisms";
import {
  CustomTab,
  CustomTabs,
  OrdersTabHeader,
  TabPanel,
} from "../components-molecules";
import CssBaseline from "@material-ui/core/CssBaseline";
import { roleName } from "../utils/roles";
import { theme } from "../constants/theme";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setSelectedOrderTab } from "../redux/actions/orders";
import { useCallback, useEffect, useState } from "react";
import {
  getPendingOrders,
  clearPendingOrders,
} from "../redux/actions/pendingOrders";
import {
  getFailedOrders,
  clearFailedOrders,
} from "../redux/actions/failedOrders";
import {
  getQueuedOrders,
  clearQueuedOrders,
} from "../redux/actions/queuedOrders";
import {
  getDispatchedOrders,
  clearDispatchedOrders,
} from "../redux/actions/dispatchedOrders";
import { getshopNames } from "../redux/actions/getShopNames";
import { setOrderInterval } from "../redux/actions/orderInterval";
import { debounce } from "lodash";
import { setOrderSortFilter } from "../redux/actions/orderSortFilter";
import { NewOrderDialog } from "../components-molecules/NewOrderDialog";
import { clearCheckNewOrdersPending } from "../redux/actions/checkNewOrdersPending";
import {
  clearCheckNewOrdersQueued,
  getCheckNewOrdersQueued,
} from "../redux/actions/checkNewOrdersQueued";
import {
  clearCheckNewOrdersFailed,
  getCheckNewOrdersFailed,
} from "../redux/actions/checkNewOrdersFailed";
import {
  clearCheckNewOrdersArchived,
  getCheckNewOrdersArchived,
} from "../redux/actions/checkNewOrdersArchived";
import React from "react";
import { usePageVisibility } from "react-page-visibility";
import { HeaderWithButtonsResponsive } from "../components-molecules/HeaderWithButtonsResponsive";
import { IShopByMerchant } from "../redux/reducers/getShopNames";

export type OrderSortType = "asc" | "desc";

export interface ISortItem {
  title: string;
  value: OrderSortType;
}
const getSortTypes = (t: any): ISortItem[] => [
  {
    title: t('collectionOrders.sort.dateAscending'),
    value: "asc",
  },
  {
    title: t('collectionOrders.sort.dateDescending'),
    value: "desc",
  },
];
const filters = {
  Status: [
    { title: "Out for Delivery", value: "outfordeliverydelivery" },
    { title: "Delivered", value: "delivereddelivery" },
    { title: "Rejected", value: "rejecteddelivery" },
    { title: "Cancelled", value: "cancelleddelivery" },
    { title: "Failed", value: "faileddelivery" },
  ],
  Date: [
    { title: "From", value: null },
    { title: "To", value: null },
  ],
};
const emptyFilter = {
  0: {
    Status: [],
    Date: [],
    Shop: [],
  },
  1: {
    Status: [],
    Date: [],
    Shop: [],
  },
  2: {
    Status: [],
    Date: [],
    Shop: [],
  },
  3: {
    Status: [],
    Date: [],
    Shop: [],
  },
};
const Orders = (props: any) => {
  const { t } = useTranslation();
  const pageVisible = usePageVisibility();
  const classes = useStyles();
  const { isFromDetails } = useParams<{ isFromDetails: string | undefined }>();
  const history = useHistory<{ from: string }>();
  const [tabIndex, interval, globalFilter]: [number, number, any] = useSelector(
    (state: any) => [
      state.OrdersReducer.selectedTab,
      state.OrderInterval.interval,
      state.OrderSortFilterReducer.data,
    ]
  );

  const role = useSelector((state: any) => state.login.role);
  const [
    checkNewOrdersArchivedData,
    checkNewOrdersFailedData,
    checkNewOrdersPendingData,
    checkNewOrdersQueuedData,
  ]: any = useSelector((state: any) => [
    state.checkNewOrdersArchived.data,
    state.checkNewOrdersFailed.data,
    state.checkNewOrdersPending.data,
    state.checkNewOrdersQueued.data,
  ]);
  const [
    checkNewOrdersArchivedTimeStamp,
    checkNewOrdersFailedTimeStamp,
    checkNewOrdersQueuedTimeStamp,
  ]: any = useSelector((state: any) => [
    state.checkNewOrdersArchived.timeStamp,
    state.checkNewOrdersFailed.timeStamp,
    state.checkNewOrdersPending.timeStamp,
    state.checkNewOrdersQueued.timeStamp,
  ]);
  const [
    pendingOrdersLoading,
    queuedOrdersLoading,
    failedOrdersLoading,
    dispatchOrdersLoading,
  ] = useSelector((state: any) => [
    state.pendingOrders.loading,
    state.queuedOrders.loading,
    state.failedOrders.loading,
    state.dispatchOrders.loading,
  ]);
  const [newOrderDialogVisible, setNewOrderDialogVisible] = useState(false);
  const [newOrderTabNameText, setNewOrderTabNameText] = useState("");
  const intervalDuration: number = 30_000;
  const timeoutDuration: number = 500;
  const [sortType, setSortType] = useState<OrderSortType>(
    isFromDetails ? globalFilter.orderBy : "desc"
  );
  const [searchOpen, setSearchOpen] = useState<{
    0: boolean;
    1: boolean;
    2: boolean;
    3: boolean;
  }>({
    0: false,
    1: false,
    2: false,
    3: false,
  });
  const [filter, setFilter] = useState<any>(
    isFromDetails ? globalFilter.filter : emptyFilter
  );
  const [query, setQuery] = useState<{
    0: string;
    1: string;
    2: string;
    3: string;
  }>(isFromDetails ? globalFilter.query : { 0: "", 1: "", 2: "", 3: "" });
  const [filterOptions, setFilterOptions] = useState<any>(
    role === "Admin" ? { Date: filters.Date, Shop: [] } : { Date: filters.Date }
  );
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const dispatch = useDispatch();
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      switch (tabIndex) {
        case 0:
          dispatch(clearPendingOrders());
          break;
        case 1:
          dispatch(clearQueuedOrders());
          break;
        case 2:
          dispatch(clearFailedOrders());
          break;
        case 3:
          dispatch(clearDispatchedOrders());
          break;
        default:
          break;
      }

      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (role === "Admin") {
      dispatch(
        getshopNames((resp) => {
          const flatShops: IShopByMerchant[] = resp.Result.flatMap((m) => m.Shops);
          setFilterOptions({
            ...filterOptions,
            Shop: flatShops.map((shop) => ({
              title: shop.ShopName,
              value: shop.ShopId,
            })),
          });
        })
      );
    }
  }, [dispatch]);
  useEffect(() => {
    if (tabIndex !== 2) {
      let temp = filterOptions;
      delete temp.Status;
      setFilterOptions(temp);
    } else {
      setFilterOptions({ ...filterOptions, Status: filters.Status });
    }
  }, [tabIndex]);
  const getOrders = useCallback(
    (role, pageNumber) => {
      if (pageNumber === 1) {
        clearOrders(tabIndex);
      }
      if (tabIndex === 0) {
        dispatch(
          getPendingOrders(
            {
              Filter: filter[0],
              OrderBy: sortType,
              Query: query[0],
              Page: pageNumber,
              Size: pageSize,
            },
            () => { },
            role
          )
        );
      } else if (tabIndex === 1) {
        dispatch(
          getQueuedOrders({
            Filter: filter[1],
            OrderBy: sortType,
            Query: query[1],
            Page: pageNumber,
            Size: pageSize,
          })
        );
      } else if (tabIndex === 2) {
        //Get data for failed deliveryies
        dispatch(
          getFailedOrders({
            Filter: filter[2],
            OrderBy: sortType,
            Query: query[2],
            Page: pageNumber,
            Size: pageSize,
          })
        );
      } else if (tabIndex === 3) {
        dispatch(
          getDispatchedOrders({
            Filter: filter[3],
            OrderBy: sortType,
            Query: query[3],
            Page: pageNumber,
            Size: pageSize,
          })
        );
      }
      dispatch(
        setOrderSortFilter({
          filter: filter,
          orderBy: sortType,
          query: query,
        })
      );
    },
    [dispatch, sortType, filter, query, tabIndex]
  );

  useEffect(() => {
    switch (tabIndex) {
      case 0:
        if (checkNewOrdersPendingData) {
          if (scrollPosition < 300) {
            if (!pendingOrdersLoading) {
              dispatch(clearPendingOrders());
              setPage(1);
              getOrders(role, 1);
            }
          } else if (scrollPosition >= 300) {
            setNewOrderTabNameText("open");
            setNewOrderDialogVisible(true);
          }
          dispatch(clearCheckNewOrdersPending());
        }
        break;
      case 1:
        if (checkNewOrdersQueuedData) {
          if (scrollPosition < 300) {
            if (!queuedOrdersLoading) {
              dispatch(clearQueuedOrders());
              setPage(1);
              getOrders(role, 1);
            }
          } else if (scrollPosition >= 300) {
            setNewOrderTabNameText("ready for collection");
            setNewOrderDialogVisible(true);
          }
          dispatch(clearCheckNewOrdersQueued());
        }
        break;
      case 2:
        if (checkNewOrdersFailedData) {
          if (scrollPosition < 300) {
            if (!failedOrdersLoading) {
              dispatch(clearFailedOrders());
              setPage(1);
              getOrders(role, 1);
            }
          } else if (scrollPosition >= 300) {
            setNewOrderTabNameText("failed");
            setNewOrderDialogVisible(true);
          }
          dispatch(clearCheckNewOrdersFailed());
        }
        break;
      case 3:
        if (checkNewOrdersArchivedData) {
          if (scrollPosition < 300) {
            if (!dispatchOrdersLoading) {
              dispatch(clearDispatchedOrders());
              setPage(1);
              getOrders(role, 1);
            }
          } else if (scrollPosition >= 300) {
            setNewOrderTabNameText("archive");
            setNewOrderDialogVisible(true);
          }
          dispatch(clearCheckNewOrdersArchived());
        }
        break;
      default:
        break;
    }
  }, [
    checkNewOrdersPendingData,
    checkNewOrdersQueuedData,
    checkNewOrdersFailedData,
    checkNewOrdersArchivedData,
  ]);

  const checkNewOrders = () => {
    switch (tabIndex) {
      case 0:
        // dispatch(getCheckNewOrdersPending(checkNewOrdersPendingTimeStamp));

        break;
      case 1:
        dispatch(getCheckNewOrdersQueued(checkNewOrdersQueuedTimeStamp));
        break;
      case 2:
        dispatch(getCheckNewOrdersFailed(checkNewOrdersFailedTimeStamp));

        break;
      case 3:
        dispatch(getCheckNewOrdersArchived(checkNewOrdersArchivedTimeStamp));
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (pageVisible) {
      let newInterval;
      clearInterval(interval);
      newInterval = setInterval(() => {
        checkNewOrders();
      }, intervalDuration);
      dispatch(setOrderInterval(newInterval));
    } else {
      clearInterval(interval);
      dispatch(setOrderInterval(0));
    }
  }, [tabIndex, pageVisible]);

  useEffect(() => {
    checkNewOrders();
    if (role && !checkNewOrdersPendingData) {
      getOrders(role, page);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, sortType, dispatch, getOrders, role]);

  const clearOrders = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        dispatch(clearPendingOrders());
        break;
      case 1:
        dispatch(clearQueuedOrders());
        break;
      case 2:
        dispatch(clearFailedOrders());
        break;
      case 3:
        dispatch(clearDispatchedOrders());
        break;
      default:
        break;
    }
  };

  const handleChange = (_: any, newValue: any) => {
    if (tabIndex === newValue) {
      return;
    }
    clearOrders(newValue);

    setFilter(emptyFilter);
    setPage(1);
    dispatch(setSelectedOrderTab(newValue));
  };
  const orderClicked = (item: any) => {
    history.push(
      `${roleName() !== "Shop" ? `/${roleName().toLowerCase()}` : ""
      }/orders/details/${item.Id}`
    );
  };
  const onFilterSubmit = (tab: number, thisFilter: any): void => {
    setFilter({
      ...filter,
      [tab]: {
        ...thisFilter,
        Date: thisFilter.Date.map((m) => new Date(m).toJSON()),
      },
    });
  };

  const loadMoreData = () => {
    getOrders(role, page + 1);
    setPage(page + 1);
  };
  const newOrderDialogClicked = () => {
    setNewOrderDialogVisible(false);
    switch (tabIndex) {
      case 0:
        dispatch(clearPendingOrders());
        break;
      case 1:
        dispatch(clearQueuedOrders());
        break;
      case 2:
        dispatch(clearFailedOrders());
        break;
      case 3:
        dispatch(clearDispatchedOrders());
        break;
      default:
        break;
    }
    setPage(1);
    setTimeout(() => {
      getOrders(role, 1);
    }, 100);
  };
  const checkFiltersApplied = () => {
    switch (tabIndex) {
      case 0:
        return filtersApplied(filter[0]);
      case 1:
        return filtersApplied(filter[1]);
      case 2:
        return filtersApplied(filter[2]);
      case 3:
        return filtersApplied(filter[3]);
      default:
        return false;
    }
  };
  const filtersApplied = (data: any) => {
    let applied = false;

    Object.values(data).forEach((x: any) => {
      if (x.length > 0) {
        applied = true;
      }
    });
    return applied;
  };

  const ORDERS_TABS = [
    t('collectionOrders.tabs.openOrders'),
    t('collectionOrders.tabs.readyForCollection'),
    t('collectionOrders.tabs.failed'),
    t('collectionOrders.tabs.archive'),
  ];

  const renderTabs = () => {
    return (
      <Container className={classes.tabContainer}>
        <CustomTabs value={tabIndex} onChange={handleChange}>
          {ORDERS_TABS.map((tab: string, idx: number) => (
            <CustomTab key={idx} label={tab} />
          ))}
        </CustomTabs>
      </Container>
    );
  };

  const debouncedOpenOrders = React.useRef(
    debounce(async (text) => {
      setPage(1);
      dispatch(clearPendingOrders());
      setQuery({ ...query, 0: text });
    }, timeoutDuration)
  ).current;
  const debouncedReadyForCollection = React.useRef(
    debounce(async (text) => {
      setPage(1);
      dispatch(clearQueuedOrders());
      setQuery({ ...query, 1: text });
    }, timeoutDuration)
  ).current;
  const debouncedFailed = React.useRef(
    debounce(async (text) => {
      setPage(1);
      dispatch(clearFailedOrders());
      setQuery({ ...query, 2: text });
    }, timeoutDuration)
  ).current;
  const debouncedArchived = React.useRef(
    debounce(async (text) => {
      setPage(1);
      dispatch(clearDispatchedOrders());
      setQuery({ ...query, 3: text });
    }, timeoutDuration)
  ).current;

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        {/* <HeaderWithButtons title="Orders" /> */}
        <HeaderWithButtonsResponsive title={t('orders.title')} />
        {renderTabs()}
        <TabPanel style={{ paddingTop: 0 }} value={tabIndex} index={0}>
          <OrdersTabHeader
            sortTypes={getSortTypes(t)}
            sortType={sortType}
            handleSortSelect={(sortItem) => {
              if (sortType !== sortItem.value) {
                setPage(1);
                dispatch(clearPendingOrders());
                setSortType(sortItem.value);
              }
            }}
            onFilterSubmit={(thisFilter) => {
              setPage(1);
              dispatch(clearPendingOrders());
              onFilterSubmit(0, thisFilter);
            }}
            filterOptions={filterOptions}
            filter={filter[0]}
            searchOpen={searchOpen[0]}
            query={query[0]}
            onSearchCancel={() => {
              setPage(1);
              dispatch(clearPendingOrders());
              setSearchOpen({ ...searchOpen, 0: false });
              setQuery({ ...query, 0: "" });
            }}
            onSearchChange={(event) => debouncedOpenOrders(event.target.value)}
            onSearchIconClick={() =>
              setSearchOpen({ ...searchOpen, 0: !searchOpen[0] })
            }
          />
          <OpenOrders
            query={query[0]}
            onClick={orderClicked}
            isFocused={tabIndex === 0 ? true : false}
            loadMoreData={loadMoreData}
            page={page}
            filterApplied={checkFiltersApplied()}
          />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={tabIndex} index={1}>
          <OrdersTabHeader
            sortTypes={getSortTypes(t)}
            sortType={sortType}
            handleSortSelect={(sortItem) => {
              if (sortType !== sortItem.value) {
                setPage(1);
                dispatch(clearQueuedOrders());
                setSortType(sortItem.value);
              }
            }}
            onFilterSubmit={(thisFilter) => {
              setPage(1);
              dispatch(clearQueuedOrders());
              onFilterSubmit(1, thisFilter);
            }}
            filterOptions={filterOptions}
            filter={filter[1]}
            searchOpen={searchOpen[1]}
            query={query[1]}
            onSearchCancel={() => {
              setPage(1);
              dispatch(clearQueuedOrders());
              setSearchOpen({ ...searchOpen, 1: false });
              setQuery({ ...query, 1: "" });
            }}
            onSearchChange={(event) =>
              debouncedReadyForCollection(event.target.value)
            }
            onSearchIconClick={() =>
              setSearchOpen({ ...searchOpen, 1: !searchOpen[1] })
            }
          />
          <ReadyForCollectionOrders
            onClick={orderClicked}
            query={query[1]}
            isFocused={tabIndex === 1 ? true : false}
            loadMoreData={loadMoreData}
            page={page}
            filterApplied={checkFiltersApplied()}
          />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={tabIndex} index={2}>
          <OrdersTabHeader
            sortTypes={getSortTypes(t)}
            sortType={sortType}
            handleSortSelect={(sortItem) => {
              if (sortType !== sortItem.value) {
                setPage(1);
                dispatch(clearFailedOrders());
                setSortType(sortItem.value);
              }
            }}
            onFilterSubmit={(thisFilter) => {
              setPage(1);
              dispatch(clearFailedOrders());
              onFilterSubmit(2, thisFilter);
            }}
            filterOptions={filterOptions}
            filter={filter[2]}
            searchOpen={searchOpen[2]}
            query={query[2]}
            onSearchCancel={() => {
              setPage(1);
              dispatch(clearFailedOrders());
              setSearchOpen({ ...searchOpen, 2: false });
              setQuery({ ...query, 2: "" });
            }}
            onSearchChange={(event) => debouncedFailed(event.target.value)}
            onSearchIconClick={() =>
              setSearchOpen({ ...searchOpen, 2: !searchOpen[2] })
            }
          />
          <FailedOrders
            onClick={orderClicked}
            query={query[2]}
            isFocused={tabIndex === 2 ? true : false}
            loadMoreData={loadMoreData}
            page={page}
            filterApplied={checkFiltersApplied()}
          />
        </TabPanel>
        <TabPanel style={{ paddingTop: 0 }} value={tabIndex} index={3}>
          <OrdersTabHeader
            sortTypes={getSortTypes(t)}
            sortType={sortType}
            handleSortSelect={(sortItem) => {
              if (sortType !== sortItem.value) {
                setPage(1);
                dispatch(clearDispatchedOrders());
                setSortType(sortItem.value);
              }
            }}
            onFilterSubmit={(thisFilter) => {
              setPage(1);
              dispatch(clearDispatchedOrders());
              onFilterSubmit(3, thisFilter);
            }}
            filterOptions={filterOptions}
            filter={filter[3]}
            searchOpen={searchOpen[3]}
            query={query[3]}
            onSearchCancel={() => {
              setPage(1);
              dispatch(clearDispatchedOrders());
              setSearchOpen({ ...searchOpen, 3: false });
              setQuery({ ...query, 3: "" });
            }}
            onSearchChange={(event) => debouncedArchived(event.target.value)}
            onSearchIconClick={() =>
              setSearchOpen({ ...searchOpen, 3: !searchOpen[3] })
            }
          />
          <CollectedOrders
            onClick={orderClicked}
            query={query[3]}
            isFocused={tabIndex === 3 ? true : false}
            loadMoreData={loadMoreData}
            page={page}
            filterApplied={checkFiltersApplied()}
          />
        </TabPanel>
      </Container>
      <NewOrderDialog
        visible={newOrderDialogVisible}
        tabName={newOrderTabNameText}
        onClick={newOrderDialogClicked}
      />
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: 840,
    paddingLeft: 0,
    paddingRight: 0,
  },
  tabContainer: {
    marginTop: "12px",
    paddingLeft: "24px",
    paddingRight: "24px",
    backgroundColor: theme.palette.background.paper,
  },
  heading: {
    paddingLeft: "24px",
    marginBottom: "14px",
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  buttonSet: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "24px",
  },
});

export default Orders;
